import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";

import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";
import Constants from "../../../../common/Constants";
import ItemService from "../../../../services/commonService";
import { toastFunc } from "../../../../components/common/util";

const ChemicalBatchViewJobcards = ({ show, onHide, chemicalBatch }) => {
  const { t } = useTranslation();

  const [jobcardData, setJobcardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (show && chemicalBatch) {
      fetchChemicalBatchJobcards();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chemicalBatch]);

  const fetchChemicalBatchJobcards = async () => {
    setLoading(true);
    setError("");

    const param = {
      url: "getChemicalBatchViewJobcards",
      chemicalBatch,
    };

    try {
      const item = await ItemService.getChemicalBatchViewJobcards(param);
      if (item?.status === 200) {
        setJobcardData(Array.isArray(item?.data) ? item.data : []);
      } else {
        setError("Failed to load jobcard records.");
        setJobcardData([]);
      }
    } catch (error) {
      console.error("Error loading jobcard records:", error);
      setError("Something went wrong while loading jobcard records.");

      toastFunc(
        Constants.MASTER.TOAST.error,
        "Something went wrong while loading jobcard records.",
        4000,
      );
    } finally {
      setLoading(false);
    }
  };

  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
      conditionalCellStyles: [
        {
          when: (row) => true, // apply to all rows
          style: {
            position: "sticky",
            left: "0px",
            background: "#fff",
            zIndex: 2,
            boxShadow: "2px 0 5px -2px #ddd",
          },
        },
      ],
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    // {
    //   name: t("msg_trasaction.msg_generatejobcard.requiredDate"),
    //   selector: (row) => row.requiredDate,
    //   sortable: true,
    //   width: "140px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)}</p>
    //     </div>
    //   ),
    // },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_customer"),
    //   selector: (row) => row.customerName,
    //   sortable: true,
    //   width: "200px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.customerName}</p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_plan"),
    //   selector: (row) => row.plan,
    //   sortable: true,
    //   width: "120px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{moment(row.plan).format("MMM-YYYY")}</p>
    //     </div>
    //   ),
    // },
    // {
    //   name: t("msg_reports.msg_jobstatus_report.col_planType"),
    //   selector: (row) => row.planType,
    //   sortable: true,
    //   width: "120px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1">{row.planType}</p>
    //     </div>
    //   ),
    // },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.batchTotalQtyDozen,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-text-status">
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard_status"),
      selector: (row) => row.jobcardStatus,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          {row.jobcardStatus === "Inprogress" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Open" ? (
            <span className="bg-table-status bg-table-new-status">
              {/* {row.jobcardStatus} */}
              NOT Acknowledged
            </span>
          ) : row.jobcardStatus === "Stopped" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Closed" ? (
            <span className="bg-table-status bg-table-info-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Complete" ? (
            <span className="bg-table-status bg-table-documentNumber-status">
              {row.jobcardStatus}
            </span>
          ) : (
            <>{row.jobcardStatus}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
  ];

  return (
    <Modal
      show={show}
      onHide={loading ? undefined : onHide}
      animation={false}
      dialogClassName="modal-90w"
      backdrop="static"
      keyboard={!loading}
    >
      <ModalHeader title="Jobcard Records" onHide={onHide} />

      <ModalBody>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" />
            <p className="mt-2 mb-0">Loading Jobcard records...</p>
          </div>
        ) : error ? (
          <Alert variant="danger">{error}</Alert>
        ) : jobcardData.length === 0 ? (
          <div className="text-center py-5">
            <h6 className="text-muted mb-2">No Jobcard Records Found</h6>
            <p className="text-muted mb-0">
              There are no Jobcard records available for this consumables batch.
            </p>
          </div>
        ) : (
          <MasterList
            columnsData={columnsData}
            rowsData={jobcardData}
            paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
            pagination
            selectableRows={false}
            handleClose={false}
            cardHeader={false}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ChemicalBatchViewJobcards;
